import { SemantriaConfigurationDto } from 'app/providers/semantria-api/configuration.service';
import { ImportStrategy } from './import-strategy';

export class NoopImportStrategy implements ImportStrategy {
  doImport = (source, target, configIncludeData) => {
    const dto = JSON.parse(JSON.stringify(target));

    dto.notes = this.assembleNotes(source, target);
    dto.tags = this.assembleTags(source, target);

    if (!configIncludeData.includes.notes) {
      dto.notes = undefined;
    }

    if (!configIncludeData.includes.tags) {
      dto.tags = undefined;
    }

    return {
      configDto: dto,
      itemsToCreate: {},
      itemsToDelete: {},
      itemsToUpdate: {},
    };
  };

  countItems = (source: SemantriaConfigurationDto, target, itemProps) => {
    const count = new Map<string, number>();

    itemProps.forEach((item) => count.set(item.prop, target[item.prop]?.length || 0));

    return count;
  };

  assembleNotes = (source: SemantriaConfigurationDto, target: SemantriaConfigurationDto) => {
    return target.notes || '';
  };

  assembleTags = (source: SemantriaConfigurationDto, target: SemantriaConfigurationDto) => {
    return target.tags || [];
  };
}
